import Phaser from "phaser";
let replayButton
export default class StartScene extends Phaser.Scene {

    constructor() {
        super('start-scene')
    }

    preload() {
        this.load.image('background', 'images/bg_layer1.png')
        this.load.image('start-bg', 'images/start.png')

    }

    create(){
        this.add.image(240, 320, 'background')

        this.startButton = this.add.image(240, 420, 'start-bg').setInteractive().setScale(0.35)

        // ketika di klik, scene akan berpindah ke BunnyJumpScene
        this.startButton.once('pointerup', () => {
            this.scene.start('bunny-jump-scene')
        }, this)
    }
}